/* import __COLOCATED_TEMPLATE__ from './social-media.hbs'; */
import { SOCIAL_MEDIA_FIELDS } from 'client-portal/models/practice-website';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class PracticeWebsiteEditMenuSocialMedia extends Component {
  socialMediaFields = SOCIAL_MEDIA_FIELDS;
}
